import React, {useContext} from 'react';
import {QuestionsContext} from '../context/questions';
import Fade from 'react-reveal/Fade';

const Loans = ({item}) => {
    const {clearList, type} = useContext(QuestionsContext);
    const cleanType = type === 'rent' ? 'rent' : 'buy'; 
    const cleanLink = item.Loan[0].replace(/\s+/g, '');
    const cleanMessage = item.message === false ? "" : item.message;
    const link = `/${cleanType}/eligibility/tool/${cleanLink}`;    

    return <Fade bottom>
    <div className="no-loan">
            <div className="titleArea">
            <div dangerouslySetInnerHTML={{__html: cleanMessage }} />
                <div className="utility-buttons">
                    <button 
                        className="su-button su-reset"
                        onClick={clearList} 
                        >
                        Reset
                    </button>
                    <a className="su-button" href={link}>See Your Programs</a>
                </div>
            </div>
        </div>
    </Fade>
    
}

export default Loans;